import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
const LOGO_IMG = 'https://cdn.magicpatterns.com/uploads/wasYCs8DibeJzMvCRTngbW/WhatsApp_Image_2026-08-10_at_10.58.30_PM.jpg';
type HeaderProps = {
  onCTA: () => void;
};
export function Header({
  onCTA
}: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-crema/95 shadow-sm backdrop-blur-md' : 'bg-crema/70 backdrop-blur-sm'}`} data-id="element-79" data-mp="31bfaxb9g4n3n">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-80" data-mp="3ba4vxcwn2no4">
        <a href="#inicio" className="flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded-lg" data-id="element-81" data-mp="3fbq4wn61yht1">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-crema" data-id="element-82" data-mp="2wiro7mnmkjqh">
            <img src={LOGO_IMG} alt="Logo Cambio Hormonal" className="h-full w-full object-cover" data-id="element-83" data-mp="2mmon8k4ier54" />
          </span>
          <span className="leading-tight" data-id="element-84" data-mp="2hpeqejesjd79">
            <span className="block font-serif text-base font-semibold text-tinta sm:text-lg" data-id="element-85" data-mp="3fb2mf37c3ti9">
              Vuelve a Vivir
            </span>
            <span className="block text-[10px] uppercase tracking-[0.2em] text-dorado sm:text-xs" data-id="element-86" data-mp="3acrcytkybl0k">
              El Método del 1%
            </span>
          </span>
        </a>
        <CTAButton onClick={onCTA} className="hidden sm:inline-flex" data-id="element-87" data-mp="30n7s5idohh32">
          Quiero mi app ahora
        </CTAButton>
        <CTAButton onClick={onCTA} className="sm:hidden !px-4 !py-2.5 !text-xs" data-id="element-88" data-mp="1x7khws3u6mk">
          Quiero mi app
        </CTAButton>
      </div>
    </header>;
}